module.exports = __webpack_public_path__ + "static/media/mail.b13629a0.svg";